/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Payment Item
 * @export
 */
export const MemberPaymentItem = {
    Dues: 'dues',
    GolfCartFee: 'golf_cart_fee',
    Campsite: 'campsite',
    Other: 'other'
} as const;
export type MemberPaymentItem = typeof MemberPaymentItem[keyof typeof MemberPaymentItem];


export function instanceOfMemberPaymentItem(value: any): boolean {
    for (const key in MemberPaymentItem) {
        if (Object.prototype.hasOwnProperty.call(MemberPaymentItem, key)) {
            if (MemberPaymentItem[key as keyof typeof MemberPaymentItem] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MemberPaymentItemFromJSON(json: any): MemberPaymentItem {
    return MemberPaymentItemFromJSONTyped(json, false);
}

export function MemberPaymentItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberPaymentItem {
    return json as MemberPaymentItem;
}

export function MemberPaymentItemToJSON(value?: MemberPaymentItem | null): any {
    return value as any;
}

